/**
 * Show sub navigation based on scroll position
 */
(function () {
  const topMargin = 800
  let subNav = document.getElementById('subNav')
  if (subNav) {
    window.addEventListener("scroll", () => {
      // show / hide nav
      if (window.pageYOffset >= topMargin && subNav.className == 'sub') {
        subNav.className = 'sub visible';
      } else if (window.pageYOffset < topMargin) {
         subNav.className = 'sub';
      }

      // highlight active nav item
      const arr = []
      let active = false
      Array.from(document.querySelectorAll('nav.sub a')).map((el) => arr.push(el))
      arr.reverse().map(
        (el) => {
          const id = el.href.substr(el.href.indexOf('#')+1)
          const targetEl = document.getElementById(id)
          if (targetEl) {
            if (!active && targetEl.getBoundingClientRect().top <= 0) {
              el.classList.add('active')
              active = true
            } else {
              el.classList.remove('active')
            }
          }
        }
      )
    })
  }
})()

